// ------------------------------------------
// geoLocation Service
// ------------------------------------------
// geolocation uses Azure maps services (rest interface)
// at this time we use fuzzy search
// google map apiKey: 'AIzaSyDKse0A5tOaqkNPRs4pJfWu_UuQsVjEAHA'
// Azure geolocation apiKey: 'KMKzaKzA7Mb7wwxo6PWSAeLd02uiHFrhZFSvDrPjOH0'

// GET https://atlas.microsoft.com/search/address/json?api-version=1.0&query=33071&subscription-key=KMKzaKzA7Mb7wwxo6PWSAeLd02uiHFrhZFSvDrPjOH0&countrySet=US
// Authorization: Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6Imwzc1EtNTBjQ0g0eEJWWkxIVEd3blNSNzY4MCIsImtpZCI6Imwzc1EtNTBjQ0g0eEJWWkxIVEd3blNSNzY4MCJ9.eyJhdWQiOiJodHRwczovL21hbmFnZW1lbnQuY29yZS53aW5kb3dzLm5ldC8iLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC8yM2EwMDAzZS03MjEyLTRjODItODA0Mi1jNWU1OWFlN2Q2NzIvIiwiaWF0IjoxNjM4OTg5NjUxLCJuYmYiOjE2Mzg5ODk2NTEsImV4cCI6MTYzODk5NTI2MywiYWNyIjoiMSIsImFpbyI6IkFXUUFtLzhUQUFBQU5ER0hEc1RPbDgzZ0x0Q3NKOVV6VmtVY041WDZuY3NCbDFlSXllMWlmbUZSY1VFUEN4d3FoNjRPeHN3akNta1dFd003TmpqdWI3T1l0MjEvM09OcktoQW8ySGNjNlNqNlc1bTFRN29TbmxkdVoxT2wxRnNmMEMybG1zL2dhekhoIiwiYWx0c2VjaWQiOiIxOmxpdmUuY29tOjAwMDM0MDAxREUzNEVFRTkiLCJhbXIiOlsicHdkIiwibWZhIl0sImFwcGlkIjoiN2Y1OWE3NzMtMmVhZi00MjljLWEwNTktNTBmYzViYjI4YjQ0IiwiYXBwaWRhY3IiOiIyIiwiZW1haWwiOiJQTW9yYW5zYWlzQGlCcmVlZGVyLmNvbSIsImZhbWlseV9uYW1lIjoiTW9yYW5zYWlzIiwiZ2l2ZW5fbmFtZSI6IlBNb3JhbnNhaXNAaUJyZWVkZXIuY29tIiwiZ3JvdXBzIjpbIjE3MTAwOWNkLWFkMjQtNDRmZi04YjhhLWYwYjM3Y2E4MjQ4NSJdLCJpZHAiOiJsaXZlLmNvbSIsImlwYWRkciI6IjIxNi4yMjUuMTE5LjI0MyIsIm5hbWUiOiJQTW9yYW5zYWlzQGlCcmVlZGVyLmNvbSBNb3JhbnNhaXMiLCJvaWQiOiI0NjIwN2VmMy03YjBhLTQ0Y2QtYWQyNy0zMWYzNDdkZDYwZDYiLCJwdWlkIjoiMTAwMzIwMDBENzNERUZCMCIsInJoIjoiMC5BUlVBUGdDZ0l4Snlna3lBUXNYbG11Zldjbk9uV1gtdkxweENvRmxRX0Z1eWkwUVZBR00uIiwic2NwIjoidXNlcl9pbXBlcnNvbmF0aW9uIiwic3ViIjoiU1lCTllaNWNhc3NNZDUwNWdUZnNNbklaZ29YejRrMWpmalVsN25ZWklrNCIsInRpZCI6IjIzYTAwMDNlLTcyMTItNGM4Mi04MDQyLWM1ZTU5YWU3ZDY3MiIsInVuaXF1ZV9uYW1lIjoibGl2ZS5jb20jUE1vcmFuc2Fpc0BpQnJlZWRlci5jb20iLCJ1dGkiOiJvalBwZ3BZX1prdTBBdlVBSlowSkFBIiwidmVyIjoiMS4wIiwid2lkcyI6WyI2MmU5MDM5NC02OWY1LTQyMzctOTE5MC0wMTIxNzcxNDVlMTAiLCJiNzlmYmY0ZC0zZWY5LTQ2ODktODE0My03NmIxOTRlODU1MDkiXSwieG1zX3RjZHQiOjE1OTcwNzMxNTR9.Pw8MR7e8ctEzUrbRlxxViQ8P0GQgyCJs3XDM5psxEptwQy-9dpQWq3elma3ambkZITMxWbmKgr2Mp39tdQUbhFa5RpHmKexz0FNqLjNIQ26Qu3hInzQEJ_VDEnpbMmU1t_EtwD_lD9toQEP90QzfD-5icwenhOk1lJOMsWDx6wAbA6j2tAA5lmVsV7LEJOwWHDDtATDazGN-COGtyCnFgh24xkGm4yiq-Evwmqxhpjo3RRiSPwJi7N8bsLry8Gd-tduR9F_Ykw2VZbZGyIteXme7YRzTL0V3WeXSVL0PZKv5LL1ZwA88WNBr9JKW1sdDDEKH4pf8kqznvVkemQbeIg


import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { PostalCode, SearchFuzzyResponse } from '@common/classes/geoLocation';
import { Validate } from '@common/classes/data/validate';
import { Resolve } from '@angular/router';
// import { of, Observable, Subscriber } from 'rxjs';
// import { catchError, map } from 'rxjs/operators';

// import { Defaults } from '@common/classes/defaults';
// import { MapCredentials } from '@common/entities/mapCredentials';
// import { ScriptModel, ibCoreService } from '../core-services/core.service';
// import { GeoPoint } from '@common/entities/geo-point';
// import { GeoPointInfo } from '@common/classes/geoLocation';
// import { Address } from '@common/entities/address';
// import { Tools, ibResult } from '@common/tools';

 import * as atlas from 'azure-maps-rest';
// declare let google: any;

@Injectable( {providedIn: 'root'})
export class ibGeoLocationService {

	private subscriptionKey: string;								// key to the microsoft map service
	private url = 'https://atlas.microsoft.com/search/address';
	private format= 'json';
	private version = '1.0';
	private postalCodes: Map<string, PostalCode>;					// postal code cache

	constructor(private http: HttpClient) {
		this.subscriptionKey = environment.azureMapKey;
		this.postalCodes = new Map<string, PostalCode>();
	}

	// Generic geo query - address or part of address
	public async searchRequest(query: string, countrySet: string = 'US'): Promise<SearchFuzzyResponse> {
		return new Promise<SearchFuzzyResponse>((resolve, reject) => {
			const request = `${this.url}/${this.format}?api-version=${this.version}&subscription-key=${this.subscriptionKey}&idxSet=Geo&countrySet=${countrySet}&query=${query}`;
			try {
				this.http.get(request).subscribe((ret: Object) => {
					const response = SearchFuzzyResponse.assign(ret);
					resolve(response);
				})
			} catch(reason: any) {
				reject(reason);
			}
		});
	}

	public getPostalCode(code: string, country: string = 'US'): Promise<PostalCode> {
		return new Promise<PostalCode>((resolve, reject) => {
			if (!Validate.isValidUSZipFormat(code)) { reject(`Invalid ${country} postal code`); }
			else if (this.postalCodes.has(code)) { resolve(this.postalCodes.get(code)!); }
			else {
				// fuzzy search on azure maps
				this.searchRequest(code, country).then((resp: SearchFuzzyResponse) => {
					try {
						const postalCode = new PostalCode(resp.getResult('Geography'));
						if (postalCode.isValid) {
							this.postalCodes.set(code, postalCode);
							resolve(postalCode);
						} else {
							reject('Invalid Postalcode: code not found');
						}
					} catch(reason: any) {
						reject(reason);
					}
				}).catch((reason: any) => {
					reject(reason);
				});
			}
		});
	}


// 	private _urlRoot = Defaults.apiServerUrl + 'services/';
// 	private credentials?: MapCredentials;
// 	private scriptModel: ScriptModel;
// 	private geocoder: google.maps.Geocoder;
// 	private loading: boolean = false;

// 	constructor(private http: HttpClient,
// 				private coreService: ibCoreService) {
// 		this.credentials = undefined;
// 		this.loading = true;
// 		this.getCredentials().subscribe((res: string | MapCredentials) => {
// 			if (res instanceof MapCredentials) this.credentials = MapCredentials.assign(res);

// 			// src: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDKse0A5tOaqkNPRs4pJfWu_UuQsVjEAHA',
// 			this.scriptModel = {
// 				name: 'googleMap',
// 				src: `${this.credentials.url}?key=${this.credentials.subscriptionKey}`,
// 				loaded: false
// 			};
// 			this.coreService.loadScript(this.scriptModel).subscribe(() => {
// 				this.loading = false;
// 				// initialize here
// 			});
// 		});
// 	}

// 	fromGeoPoint(point: GeoPoint): Observable<GeoPointInfo | undefined> {
// 		if (!this.insureLoad()) {
// 			return of(undefined);
// 		}
// 		const pos: google.maps.LatLng = new google.maps.LatLng(point.latitude, point.longitude);
// 		return this.fromPoint(pos);
// 	}

// 	fromPoint(position: google.maps.LatLng): Observable<GeoPointInfo | undefined> {
// 		if (!this.insureLoad()) { return of(undefined); }
// 		if (!position) { return of(undefined); }
// 		if (!this.geocoder) { this.geocoder = new google.maps.Geocoder(); }

// 		const ret = new Observable<GeoPointInfo>((observer: Subscriber<GeoPointInfo>) => {
// 			// eslint-disable-next-line max-len
// 			this.geocoder.geocode({ location: position }, (results: Array<google.maps.GeocoderResult>, status: google.maps.GeocoderStatus) => {
// 				if (status.toString() === 'OK') {
// 					const gPointInfo = new GeoPointInfo(results);
// 					observer.next(gPointInfo);
// 					observer.complete();
// 				} else {
// 					observer.error('Geocoder failed due to: ' + status.toString());
// 					observer.complete();
// 				}
// 			});
// 		});
// 		return ret;
// 	}

// 	fromPostalCode(code: string, country: string = 'US'): Observable<GeoPointInfo | undefined> {
// 		if (!this.insureLoad()) { return of(undefined);}
// 		if (!code) { return of(undefined); }
// 		if (!this.geocoder) {this.geocoder = new google.maps.Geocoder(); }
// 		const addr = `${code} ${country}`;

// 		const ret = new Observable<GeoPointInfo>((observer: Subscriber<GeoPointInfo>) => {
// 			this.geocoder.geocode({ address: addr }, (results: Array<google.maps.GeocoderResult>, status: google.maps.GeocoderStatus) => {
// 				if (status.toString() === 'OK') {
// 					const gPointInfo = new GeoPointInfo(results);
// 					observer.next(gPointInfo);
// 					observer.complete();
// 				} else {
// 					observer.error('Geocoder failed due to: ' + status.toString());
// 					observer.complete();
// 				}
// 			});
// 		});
// 		return ret;
// 	}

// 	fromAddress(address: Address): Observable<GeoPointInfo | undefined> {
// 		if (!this.insureLoad()) { return of(undefined); }
// 		if (!address) { return of(undefined); }
// 		if (!this.geocoder) { this.geocoder = new google.maps.Geocoder(); }

// 		const addr = address.toString();

// 		const ret = new Observable<GeoPointInfo>((observer: Subscriber<GeoPointInfo>) => {
// 			this.geocoder.geocode({ address: addr }, (results: Array<google.maps.GeocoderResult>, status: google.maps.GeocoderStatus) => {
// 				if (status.toString() === 'OK') {
// 					const gPointInfo = new GeoPointInfo(results);
// 					observer.next(gPointInfo);
// 					observer.complete();
// 				} else {
// 					observer.error('Geocoder failed due to: ' + status.toString());
// 					observer.complete();
// 				}
// 			});
// 		});
// 		return ret;
// 	}


// 	// public search(address: Address | string): object {
// 	// 	if (!this.credentials) { throw new Error('Map Credentials are not loaded'); }

// 	// 	let addr: string;

// 	// 	if (address instanceof Address) {
// 	// 		addr = Address.toString();
// 	// 	}
// 	// 	return new Object();
// 	// }

// 	// public getCountryRegion(value: AccountID) {
// 	// 	if (this.credentials) {
// 	// 		const request = new MapAddressRequest(this.credentials);
// 	// 		request.countryCode = value.country.toUpperCase();
// 	// 		request.countrySubdivision = value.region.toUpperCase();
// 	// 		this.executeRequest(request.toString()).pipe(
// 	// 			map((res) => {
// 	// 				alert('getCountry region' + JSON.stringify(res, null, 4));
// 	// 			})
// 	// 		).subscribe();
// 	// 	}
// 	// }


// 	private insureLoad(count: number = 2000): boolean {
// 		while (this.loading) {
// 			Tools.sleep(100);
// 			count -= 100;
// 			if (count <= 0) { return false; }
// 		}
// 		return true;
// 	}


// 	// get google key from server
// 	private getCredentials(): Observable<MapCredentials | string> {
// 		return this.http.get<ibResult<MapCredentials | string>>(this._urlRoot + 'getMapCredentials').pipe(
// 			map((resp: ibResult<MapCredentials>) => {
// 				if (resp.isSuccess) {
// 					return <MapCredentials> resp.value;
// 				} else {
// 					return resp.message;
// 				}
// 				return '';
// 			}),
// 			catchError((err: any): string  => err.message)
// 		);
// 	}
}


class GeoAddress {}




